export const ROOT_URL = '/'
export const EXPIRE_COOKIES_URL = '/web/api/auth/expire-cookies'
export const SESSION_REFRESH_PAGE_URL = '/session-refresh'
